import { LabeledValue } from '@/components/ui/labeled-value';
import type { WireTransactionBatch } from '@/services/api/brokers';
import { formatAmount, formatBrokerDateTime } from './batch-formatters';

interface BatchSummaryStripProps {
  batch: WireTransactionBatch;
}

/** Bordered label/value grid for the loaded batch summary. */
export const BatchSummaryStrip = ({ batch }: BatchSummaryStripProps) => (
  <section aria-label="Batch summary" className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4 rounded-md border p-4">
    <LabeledValue label="Currency">{batch.currency}</LabeledValue>
    <LabeledValue label="Transactions">{batch.tx_count}</LabeledValue>
    <LabeledValue label="Deposits">
      {batch.deposit_count} · {formatAmount(batch.deposit_total)}
    </LabeledValue>
    <LabeledValue label="Withdrawals">
      {batch.withdrawal_count} · {formatAmount(batch.withdrawal_total)}
    </LabeledValue>
    <LabeledValue label="Net Amount">
      {formatAmount(batch.net_amount)} {batch.currency}
    </LabeledValue>
    <LabeledValue label="Window">
      {formatBrokerDateTime(batch.batch_window_start)} → {formatBrokerDateTime(batch.batch_window_end)}
    </LabeledValue>
    {/* Item rendered only when the batch has actually settled */}
    {batch.settled_at ? <LabeledValue label="Settled">{formatBrokerDateTime(batch.settled_at)}</LabeledValue> : null}
  </section>
);
BatchSummaryStrip.displayName = 'BatchSummaryStrip';
